<template>
  <div class="safe-footer-warp" :class="isLandscape ? 'pc' : 'm'">
    <div class="safe-footer">
      <div class="safe-item">
        <em class="ico iconfont icon-safe_icon"></em>
        <div class="safe-text">
          <p class="safe-title">{{ letter.footerSafeTitle1 }}</p>
          <p class="safe-content">{{ letter.footerSafeContent1 }}</p>
        </div>
      </div>
      <div class="safe-item">
        <em class="ico iconfont icon-cart_icon"></em>
        <div class="safe-text">
          <p class="safe-title">{{ letter.footerSafeTitle2 }}</p>
          <p class="safe-content">{{ letter.footerSafeContent2 }}</p>
        </div>
      </div>
      <div class="safe-item">
        <em class="ico iconfont icon-discount_icon"></em>
        <div class="safe-text">
          <p class="safe-title">{{ letter.footerSafeTitle3 }}</p>
          <p class="safe-content">{{ letter.footerSafeContent3 }}</p>
        </div>
      </div>
      <div class="safe-item">
        <em class="ico iconfont icon-time_icon"></em>
        <div class="safe-text">
          <p class="safe-title">{{ letter.footerSafeTitle4 }}</p>
          <p class="safe-content">{{ letter.footerSafeContent4 }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  data() {
    return {
      isLandscape: window.innerWidth > window.innerHeight
    };
  },
  computed: {
    ...mapState({
      letter: state => state.letter
    })
  }
};
</script>

<style scoped lang="scss">
@import '@assets/scss/officialWebStore/officialWebStore.scss';

.m {
  &.safe-footer-warp {
    padding: 0 20px;
    .safe-footer {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      .safe-item {
        margin-top: 20px;
        display: flex;
        width: 293px;
        padding: 22px 20px;
        border-radius: 12px;
        border: solid 3px #e1e1e1;

        .safe-text {
          margin-left: 18px;
          .safe-title {
            font-size: 34px;
            color: #333333;
          }
          .safe-content {
            margin-top: 10px;
            font-size: 20px;
            color: #999999;
          }
        }
        .ico {
          display: block;
          font-size: 55px;
        }
      }
    }
  }
}
.pc {
  &.safe-footer-warp {
    position: relative;
    width: 100%;
    margin-top: 30px;
    border-radius: 10px;
    background-color: #fff;
    box-shadow: 0px 10px 10px #e7e7e7;
    .safe-footer {
      padding: 20px;
      height: unset;
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      .safe-item {
        display: flex;
        flex-direction: column;
        position: relative;
        justify-content: flex-start;
        flex-direction: row;
        border: none;
        border-bottom: 1px solid #dfdfdf;
        width: 100%;
        padding: 17px 0;

        &:last-child {
          border-bottom: none;
        }
        .safe-text {
          display: flex;
          flex-direction: column;
          align-items: start;
          margin-left: 24px;
          .safe-title {
            font-size: 24px;
            color: #333333;
          }
          .safe-content {
            margin-top: 10px;
            font-size: 16px;
            color: #999999;
          }
        }
        .ico {
          font-size: 30px;
        }
      }
    }
  }
}
</style>
